export default __webpack_public_path__ + "media/color/ion-48eb1d79.svg";